import { z } from 'zod';
export const CreatePushSubscriptionSchema = z.object({
    endpoint: z.url(),
    keys: z.object({
        p256dh: z.string().min(1),
        auth: z.string().min(1),
    }),
});
//# sourceMappingURL=push-subscriptions.js.map